module.exports = __webpack_public_path__ + "static/media/thumb.ae2d0cf3.jpg";